import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, namespace } from 'vuex-class';

import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import Pagination from '@/components/Includes/Pagination/Pagination.vue';
import SelectionColumnsInTable from '@/components/Includes/SelectionColumnsInTable/SelectionColumnsInTable.vue';
import TableEmpty from '@/components/Includes/Table/TableFooter/TableEmpty/TableEmpty.vue';
import ITableCol from '@/interfaces/ITableCol';
import ITariff from '@/interfaces/ITariff';
import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import ISelectItemDefault from '@/interfaces/selects/ISelectItemDefault';
import getTableColumns from '@/libs/getTableColumns';
import listOfTableFieldsForSelection from '@/libs/listOfTableFieldsForSelection';
import IPaymentProviderModel from '@/interfaces/IPaymentProviderModel';

const today = new Date();
const paymentProviderModelModule = namespace('paymentProviderModel');

@Component({
    name: 'ReceiptsList',
    components: {
        'vue-picker': VueCtkDateTimePicker,
        CardHeader,
        Pagination,
        SelectionColumnsInTable,
        TableEmpty,
        Loader
    }
})
export default class ReceiptsList extends Vue {
    @paymentProviderModelModule.Action private readonly fetchPaymentProviderModels!: (params: {query: string}) => Promise<IPaymentProviderModel[]>;
    @Action private tariffsList!: (params: {query: string, routeName?: string}) => Promise<void>;
    @Getter private getTariffs!: () => ITariff[];

    private loading: boolean = true;
    private tariffs: ITariff[] = [];
    private selectedTableColumns: IMultiSelectItem[] = [];

    private paymentProviderModels: {[key: string]: IPaymentProviderModel} = {};

    // Begin configs for Pagination
    private totalTariffs: number | void | null = null;

    private currentPage: number = 1;

    private selectedLimit: string = '100';

    private limits: ISelectItemDefault[] = [
        { value: '100', text: '100' },
        { value: '250', text: '250' },
        { value: '500', text: '500' }
    ]
    // End configs for Pagination

    private get tableColumns(): ITableCol[] | undefined {
        return getTableColumns(this.tariffs, true);
    };

    private get fields() {
        if (Array.isArray(this.tableColumns)) {
            return listOfTableFieldsForSelection(this.tableColumns, this.selectedTableColumns)
        }
    }

    private get isSubscriptionsTariffs(): boolean {
        return this.$route.name === 'subscriptions_tariffs_list';
    }

    private get orderName(): string {
        const { order_name } = this.$route.query;

        return typeof order_name === 'string' ? order_name : '';
    }

    private set orderName(val: string) {
        this.$router.push({
            query: {
                ...this.$route.query,
                order_name: val
            }
        })
    }

    private get orderType(): boolean {
        const { order_type } = this.$route.query;

        return order_type === 'desc';
    }

    private set orderType(val: boolean) {
        this.$router.push({
            query: {
                ...this.$route.query,
                order_type: val ? 'desc' : 'asc'
            }
        })
    }


    public detailTariff(traffic: any) {
        this.$router.push({
            name: this.isSubscriptionsTariffs ? 'subscription_tariff_detail' : 'tariff_detail',
            params: { id: traffic.id, trafficData: traffic }
        });
    }

    private changedTableColumns(columnsList: IMultiSelectItem[]) {
        this.selectedTableColumns = columnsList
    }

    private get payloadQuery(): string {
        return `?pagination=true&page=${this.currentPage}&limit=${this.selectedLimit}`;
    }

    @Watch('selectedLimit')
    @Watch('currentPage')
    private async loadTariffs() {
        this.loading = true;
        this.totalTariffs = await this.tariffsList({query: this.payloadQuery, routeName: this.$route.name || undefined});
        this.tariffs = this.getTariffs();
        this.loading = false;
    }

    private async mounted() {
        const paymentProviderModels = await this.fetchPaymentProviderModels({query: `?page=1&limit=300&pagination=true`});
        paymentProviderModels.forEach(item => {
            this.$set(this.paymentProviderModels, item.id, item)
        });

        try {
            this.loadTariffs();
        } catch (error) {
            return Promise.reject('Error loading data')
        }
    }
}
